import React from 'react'
import { withIcon } from '../../withIcon'

function DotIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="3" fill={color}/>
    </svg>
  )
}

export default withIcon(DotIcon)
